import { removeFromLinkedList } from '../forms/form-helpers';
import useAuth from '../../hooks/auth-hooks';
import { ILinkedTerminals } from '../../models/cardgroup.interface';

/**
 * Function that creates and displays currently Linked terminals.
 * 
 * @param {ILinkedTerminals} data terminal data
 * @param {string} customerId the customer ID
 * @param {string} cardGroupId the card group ID
 * @param {string} partnerId the partner ID
 * @param {HTMLElement} container container for the selected item
 */
export const displayTerminals = ( data: Array<ILinkedTerminals>, customerId: string, cardGroupId: string, partnerId: string, container: HTMLElement ) => {
  const { accessType } = useAuth()!;
  console.log('diisplayTerminals', data, accessType);
  data.forEach((e: ILinkedTerminals) => {
    const div = document.createElement('div');
    div.className = `double-row-widget rick aafp_border-radius cg_access_${e.termId}`;
    div.setAttribute(`data-termid`, e.termId);
    div.setAttribute('data-name', e.termName);
    div.setAttribute('data-partner', String(e.partnerId));
    div.setAttribute('data-partnername', e.partnerName);

    const linkTerminal = document.createElement('div');
    linkTerminal.className = 'aafp_link-terminal';

    const span = document.createElement('span');
    span.textContent = e.termName;

    const i = document.createElement('i');
    i.className = `far fa-trash-alt element-remove-${e.termId}`;
    i.setAttribute('data-toggle', 'tooltip');
    i.setAttribute('data-placement', 'bottom');
    i.setAttribute('title', `Remove ${e.termName} from Card Group`);

    const divLower = document.createElement('div');
    divLower.className = 'aafp_link-taxes';

    const divTaxList = document.createElement('div');
    divTaxList.className = 'cardgroup-terminal-tax-list';

    const divContainer = document.createElement('div');

    const divContSpan = document.createElement('span');
    divContSpan.textContent = 'Taxes: ';

    const divContSpanList = document.createElement('span');
    divContSpanList.textContent = e.displayTax != '' ? e.displayTax : 'No taxes associated';

    const taxLink = document.createElement('a');    
    taxLink.setAttribute('href', `/card-group/terminal-card-group-tax?cID=${customerId}&cgID=${cardGroupId}&tID=${e.termId}&pID=${partnerId}`);
    taxLink.className = 'aafp_btn-form btn_theme-primary';
    taxLink.id = `form-button-${e.termId}`;
    if ( accessType === 'R' ) {
      taxLink.textContent = e.displayTax != '' ? 'View taxes' : ''; 
    } else {
      taxLink.textContent = e.displayTax != '' ? 'View/Edit taxes' : 'Add Taxes';
    }

    linkTerminal.appendChild(span);
    if ( accessType != 'R') {
      linkTerminal.appendChild(i);
    }
    div.appendChild(linkTerminal);
    divLower.appendChild(divTaxList);
    if ( accessType === 'E' ) {
      divLower.appendChild(taxLink);
    }
    divTaxList.appendChild(divContainer);
    divContainer.appendChild(divContSpan);
    divContainer.appendChild(divContSpanList);
    div.appendChild(divLower);

    if ( data.length > 1 ) {
      container.appendChild(div);
    } else {
      container.prepend(div);
    }
    
    removeFromLinkedList(`.element-remove-${e.termId}`, e.termId);
  });

  data.length = 0;
}